import { ReactComponent as AddToSlides } from 'assets/icons/icon-add-to-slides.svg';

export default AddToSlides;
